import { AreaChart, Area, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import "./RechartsOverrides.scss";

const UserChart = ({ data, webpage, renderTooltip, tickFormatter }) => {
	const values = data.map(d => d[webpage ? "views" : "users"]);
	const min = Math.min(...values, 0);
	const max = Math.max(...values, 1);

	//Generate whole number ticks between min and max
	const ticks = [];
	for (let i = Math.ceil(min); i <= Math.floor(max); i++) {
		ticks.push(i);
	}

	return (
		<ResponsiveContainer width="100%" height={264}>
			<AreaChart data={data} margin={{ top: 8, right: 10, left: -20, bottom: 0 }}>
				<defs>
					<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
						<stop offset="5%" stopColor="#0E8EFD" stopOpacity={0.7} />
						<stop offset="70%" stopColor="#0E8EFD" stopOpacity={0} />
					</linearGradient>
				</defs>
				<XAxis tickLine={false} axisLine={false} dataKey="name" interval={data?.length > 25 ? 4 : data?.length > 11 ? 2 : null} tickFormatter={value => tickFormatter ? tickFormatter(value) : value}/>
				<YAxis
					axisLine={false}
					tickLine={false}
					ticks={ticks.length > 5 ? null : ticks}
				/>
				<CartesianGrid vertical={false} strokeDasharray="3 3" />
				<Tooltip content={renderTooltip}/>
				<Area type="monotone" dataKey={webpage ? "views" : "users"} strokeWidth={2} stroke="#0E8EFD" fillOpacity={1} fill="url(#colorUv)" />
			</AreaChart>
		</ResponsiveContainer>
	);
}

export default UserChart;